import React, { Component, Fragment } from "react";
import { BottomScrollListener } from "react-bottom-scroll-listener";
import { connect } from "react-redux";
import cloneDeep from "lodash.clonedeep";
import * as actionTypes from "../../../../store/Actions/actions";
import Spinner from "../../../../assets/images/spinner.gif";
import * as UTILS from "../../../../utils/Utils";
import "../Library.scss";
import noImage from "../../../../assets/images/noImage.png";
import Axios from "../../../../axios";
let userID;
let sessionID;


class LicensedVideosContent extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.state = {
      loader: false,
      note: false,
      initialItems: [],
      searchString: "",
      filter: "d",
      initP: 0,
      chosenVideo: { video_id: null },
      elementID: null,
      noVideoList: false,
      reloadVideos: false,
      savingData: null,
    };
  }
  componentDidMount = () => {
    this.setState({
      elementID: this.props.ID,
    });
    this.fetchVideos(
      this.state.filter,
      this.state.initP,
      this.state.searchString
    );
  };
  componentDidUpdate() {
    if (this.props.reloadAPI == true) {
      this.setState(
        {
          ...this.state,
          initP: 0,
        },
        this.fetchVideos(this.state.filter, 0, this.state.searchString)
      );
      this.props.reloadAPICall(false);
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  handleChange(e) {
    this.setState(
      {
        ...this.state,
        searchString: e.target.value,
        initP: 0,
      },
      () => {
        if (e.target.value == "") {
          this.setState(
            {
              ...this.state,
              noVideoList: false,
              loader:true
            },
            this.fetchVideos(
              this.state.filter,
              this.state.initP,
              this.state.searchString
            )
          );
        }
      }
    );
  }

  pushVideo = (video) => {
    const layout = cloneDeep(this.props.layout);

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.src = video.image;
        item.srcID = video.video_id;
        item.licenced_video_id = video.licenced_video_id
          ? video.licenced_video_id
          : "";
        item.showChaptersToggle = video.chapters.length > 0 ? true : false;
        item.type = video.licenced_video_id ? "LICENSED VIDEO" : "VIDEO";
        item.vimeoID = null;
        item.vimeoTHUMB = null;
        item.youtubeID = null;
        item.youtubeTHUMB = null;
        item.video_url = null;
      },
      (colItem) => {
        colItem.src = video.image;
        colItem.srcID = video.video_id;
        colItem.licenced_video_id = video.licenced_video_id
          ? video.licenced_video_id
          : "";
        colItem.showChaptersToggle = video.chapters.length > 0 ? true : false;
        colItem.type = video.licenced_video_id ? "LICENSED VIDEO" : "VIDEO";
        colItem.vimeoID = null;
        colItem.vimeoTHUMB = null;
        colItem.youtubeID = null;
        colItem.youtubeTHUMB = null;
        colItem.video_url = null;
      },
      (colItemNested) => {
        colItemNested.src = video.image;
        colItemNested.srcID = video.video_id;
        colItemNested.licenced_video_id = video.licenced_video_id
          ? video.licenced_video_id
          : "";
        colItemNested.showChaptersToggle =
          video.chapters.length > 0 ? true : false;
        colItemNested.type = video.licenced_video_id
          ? "LICENSED VIDEO"
          : "VIDEO";
        colItemNested.vimeoID = null;
        colItemNested.vimeoTHUMB = null;
        colItemNested.youtubeID = null;
        colItemNested.youtubeTHUMB = null;
        colItemNested.video_url = null;
      }
    );
    // files.length > 0 ? this.props.layoutArray(this.props.layoutTitle, newLayout):null;

    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  fetchVideos = (filter, initP, searchString) => {
    userID = this.props.userID;
    sessionID = this.props.sessionID;

    this.setState({
      loader: true,
      elementID: this.props.ID,
    });
    const self = this;

    Axios.MediaService.GET_LICENSED_VIDEOS(userID, sessionID, filter, initP, searchString)
      .then((response) => {
        const data = response.data.body;

        if (response.data.statusCode === "success") {
          if (data.length == 12) {
            self.setState({
              initialItems: data,
              loader: false,
            });
          }

          if (data.length < 12) {
            this.setState({
              ...this.state,
              loader: false,
              noVideoList: true,
              initialItems: data,
            });
          }
        }
      })
      .catch(function (error) {});
  };

  sortingVideos = (e) => {
    this.fetchVideos(
      this.state.filter,
      this.state.initP,
      this.state.searchString
    );
  };


  handleScroll = () => {
    userID = this.props.userID;
    sessionID = this.props.sessionID;

    this.setState(
      {
        loader: true,
        elementID: this.props.ID,
        initP: this.state.initP + 1,
      },
      () => {
        Axios.MediaService.GET_LICENSED_VIDEOS(
          userID,
          sessionID,
          this.state.filter,
          this.state.initP,
          this.state.searchString
        )
          .then((response) => {
            const data = response.data.body;
            if (response.data.statusCode === "success") {
              if (data.length == 12) {
                this.setState({
                  initialItems: [...this.state.initialItems, ...data],
                  loader: false,
                });
              }

              if (data.length < 12) {
                this.setState({
                  ...this.state,
                  loader: false,
                  noVideoList: true,
                  initialItems: [...this.state.initialItems, ...data],
                });
              }
            }
          })
          .catch(function (error) {});
      }
    );
  };

  chooseVideo = (video) => {
    this.props.selectingContent
      ? (() => {
          this.setState(
            {
              ...this.state,
              chosenVideo: video,
            },
            this.pushVideo(video)
          );
        })()
      : "";
  };
  render() {
    let fileContent = (
      <BottomScrollListener onBottom={this.handleScroll} offset={10}>
        {(scrollRef) => (
          <div className="videosWrapper" ref={scrollRef}>
            {this.state.initialItems.map((video, i) => {
              return (
                <div
                  key={i}
                  className={
                    "video-block " +
                    (this.state.chosenVideo.video_id == video.video_id
                      ? " selectedImage"
                      : " ")
                  }
                  id={
                    this.state.chosenVideo.video_id == video.video_id
                      ? "selectedImage"
                      : null
                  }
                  onClick={() => {
                    this.chooseVideo(video);
                  }}
                >
                  <div className="imgWrapper file">
                    {" "}
                    <img
                      onError={(e) => {
                        e.target.src = noImage;
                      }}
                      src={video.image}
                    />
                  </div>
                  <p>{video.file_title ? video.file_title : "Untitled"}</p>
                </div>
              );
            })}

            {this.state.noVideoList && (
              <div
                style={{
                  textAlign: "center",
                  width: "100%",
                  color: "#898989",
                  marginTop: "-15px",
                }}
                className="contentNote"
              >
                No more content found...
              </div>
            )}
          </div>
        )}
      </BottomScrollListener>
    );
    return (
      <div>
        <div className="filtersWrapper">
          <div
            style={{ width: "100%", display: "flex", flexDirection: "row" }}
            className="selectWrapper"
          >
            <select
              className=""
              onChange={(e) => {
                this.setState(
                  {
                    ...this.state,
                    initP: 0,
                    filter: e.target.value,
                  },
                  this.sortingVideos
                );
              }}
            >
              <option value="d">Recently Uploaded</option>
              <option value="c">Chronologically</option>
              <option value="a">Alphabetically</option>
            </select>

            <input
              type="text"
              //value={this.state.searchString}
              ref="search"
              onChange={this.handleChange}
              placeholder="Search"
              className="searchVideo"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  this.fetchVideos(
                    this.state.filter,
                    this.state.initP,
                    this.state.searchString
                  );
                }
              }}
            />
            <button
              className="searchButton"
              onClick={() => {
                this.fetchVideos(
                  this.state.filter,
                  this.state.initP,
                  this.state.searchString
                );
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                xmlns:svgjs="http://svgjs.com/svgjs"
                width={20}
                height={20}
                x={0}
                y={0}
                viewBox="0 0 612.01 612.01"
                style={{
                  enableBackground: "new 0 0 512 512",
                }}
                xmlSpace="preserve"
              >
                <g>
                  <g xmlns="http://www.w3.org/2000/svg">
                    <g id="_x34__4_">
                      <g>
                        <path
                          d="M606.209,578.714L448.198,423.228C489.576,378.272,515,318.817,515,253.393C514.98,113.439,399.704,0,257.493,0     C115.282,0,0.006,113.439,0.006,253.393s115.276,253.393,257.487,253.393c61.445,0,117.801-21.253,162.068-56.586     l158.624,156.099c7.729,7.614,20.277,7.614,28.006,0C613.938,598.686,613.938,586.328,606.209,578.714z M257.493,467.8     c-120.326,0-217.869-95.993-217.869-214.407S137.167,38.986,257.493,38.986c120.327,0,217.869,95.993,217.869,214.407     S377.82,467.8,257.493,467.8z"
                          fill="#0c3254"
                          data-original="#000000"
                          style={{}}
                          className=""
                        />
                      </g>
                    </g>
                  </g>
                  <g xmlns="http://www.w3.org/2000/svg" />
                  <g xmlns="http://www.w3.org/2000/svg" />
                  <g xmlns="http://www.w3.org/2000/svg" />
                  <g xmlns="http://www.w3.org/2000/svg" />
                  <g xmlns="http://www.w3.org/2000/svg" />
                  <g xmlns="http://www.w3.org/2000/svg" />
                  <g xmlns="http://www.w3.org/2000/svg" />
                  <g xmlns="http://www.w3.org/2000/svg" />
                  <g xmlns="http://www.w3.org/2000/svg" />
                  <g xmlns="http://www.w3.org/2000/svg" />
                  <g xmlns="http://www.w3.org/2000/svg" />
                  <g xmlns="http://www.w3.org/2000/svg" />
                  <g xmlns="http://www.w3.org/2000/svg" />
                  <g xmlns="http://www.w3.org/2000/svg" />
                  <g xmlns="http://www.w3.org/2000/svg" />
                </g>
              </svg>
            </button>
          </div>
        </div>

        <div>
         
            <div style={{ zIndex: "999999999", position: "relative" }}>
              {fileContent}
              {this.state.loader && (
                <div
                  className="positionStatusVideos"
                  style={{ textAlign: "center", width: "100%" }}
                >
                  <img
                    style={{ zIndex: "999999999", position: "relative" }}
                    src={Spinner}
                  />
                </div>
              )}
            </div>
          
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    layoutTitle: state.present.layoutTitle,
    reloadAPI: state.present.reloadAPI,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
    reloadAPICall: (api) => dispatch(actionTypes.reload_api(api)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LicensedVideosContent);
